import * as React from "react";
import { forwardRef } from "react";
const SvgMicrosoft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 33, height: 33, viewBox: "0 0 33 32", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3.06671 4H15.0667V16H3.06671V4ZM15.0667 29.3333H3.06671V17.3333H15.0667V29.3333ZM28.4 4V16H16.4V4H28.4ZM28.4 29.3333H16.4V17.3333H28.4V29.3333Z", fill: "black" }));
const ForwardRef = forwardRef(SvgMicrosoft);
export { ForwardRef as ReactComponent };
